import React from 'react';
import { ORDER_STATUS, ORDER_STATUS_LABELS } from '../../constants';
import { formatPrice } from '../../utils';
import { CheckCircleIcon } from '../common/Icons';

// Sipariş durumlarının renk tonu (CustomerListModern.css içindeki .cl-tone-* sınıfları)
export const STATUS_TONES = {
  [ORDER_STATUS.NEW_ORDER]: 'neutral',
  [ORDER_STATUS.FIRMA]: 'info',
  [ORDER_STATUS.ATOLYE]: 'accent',
  [ORDER_STATUS.MONTAJ]: 'violet',
  [ORDER_STATUS.DELIVERED]: 'success',
};

// "905321234567" -> "+90 532 123 45 67"
export const displayPhone = (phone) => {
  const digits = (phone || '').replace(/\D/g, '');
  const local = digits.startsWith('90') && digits.length === 12 ? digits.slice(2) : digits.replace(/^0/, '');
  if (local.length !== 10) return phone || '';
  return `+90 ${local.slice(0, 3)} ${local.slice(3, 6)} ${local.slice(6, 8)} ${local.slice(8)}`;
};

export const getInitials = (name) => {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const initials = parts.length > 1 ? parts[0][0] + parts[parts.length - 1][0] : parts[0].slice(0, 2);
  return initials.toLocaleUpperCase('tr-TR');
};

export const StatusChip = ({ status }) => {
  const key = status || ORDER_STATUS.NEW_ORDER;
  return (
    <span className={`cl-chip cl-tone-${STATUS_TONES[key] || 'neutral'}`}>
      <span className="cl-chip-dot" aria-hidden="true" />
      {ORDER_STATUS_LABELS[key] || key}
    </span>
  );
};

// Kalan ödeme: undefined = hesaplanıyor, -1 = sipariş yok, 0 / tamamlandı = ödendi
export const PaymentChip = ({ amount, completed }) => {
  if (amount === undefined) return <span className="cl-skeleton" aria-label="Hesaplanıyor" />;
  if (amount === -1) return <span className="cl-pay cl-pay-none">Sipariş yok</span>;
  if (completed || amount === 0) {
    return (
      <span className="cl-pay cl-pay-done">
        <CheckCircleIcon size={14} strokeWidth={2} /> Ödendi
      </span>
    );
  }
  return <span className="cl-pay cl-pay-due">{formatPrice(amount)} ₺</span>;
};
